var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":"預覽","visible":_vm.mIsShow,"append-to-body":"","width":"592px","height":"500px"},on:{"update:visible":function($event){_vm.mIsShow=$event}}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.previewingPostHtml)}})])}
var staticRenderFns = []

export { render, staticRenderFns }